import React from 'react';
import { Modal } from 'antd';

function IcalInfoModal({ open, onCancel, content }) {
  return (
    <Modal
      open={open}
      footer={null}
      onCancel={onCancel}
      className="modal-md"
      aria-hidden="false"
    >
      <div className="Idmodalbox earlyCheckinPopup">
        <div className="hostPayout">
          <div className="modal-content">
            {content?.length > 0 && (
              <div>
                {content.map((item, index) => (
                  <div key={`ical-info-${index}`} className="hostPayout">
                    <div
                      className="description"
                      dangerouslySetInnerHTML={{ __html: item.description }}
                    />
                    {index < content.length - 1 && <hr />}
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </Modal>
  );
}

export default IcalInfoModal;
